export const DEVICE_TOKEN_KEY = 'seven_analytics_device_token'

export const deviceTokenStorage = {
  get: (): string => {
    let token = localStorage.getItem(DEVICE_TOKEN_KEY)
    if (!token) {
      // Gera um UUID (v4) simplificado usando crypto.randomUUID
      token = crypto.randomUUID()
      localStorage.setItem(DEVICE_TOKEN_KEY, token)
    }
    return token
  },

  set: (token: string) => {
    localStorage.setItem(DEVICE_TOKEN_KEY, token)
  },

  remove: () => {
    localStorage.removeItem(DEVICE_TOKEN_KEY)
  },
}
